import React from 'react'
import { TaskActivity } from '@core/entities/task/TaskActivity'
import { TaskActivityAuditResult } from './TaskActivityAuditResult'
import { TaskActivityCurrentStep } from './TaskActivityCurrentStep'
import { Task } from '@core/entities/task/Task'
import { TaskActivityBase } from './TaskActivityBase'

type TaskActivityWrapperProps = {
  activity: TaskActivity
  task: Task
  bgColor?: string
  isModal?: boolean
}

export const TaskActivityWrapper: React.FC<TaskActivityWrapperProps> = ({
  activity,
  task,
  bgColor,
  isModal,
}) => {
  if (!activity || !task) {
    return null
  }

  switch (activity.type) {
    case 'AUDIT_RESULT':
      return (
        <TaskActivityAuditResult
          activity={activity}
          bgColor={bgColor}
          isModal={isModal}
        />
      )
    case 'CURRENT_STEP':
      return (
        <TaskActivityCurrentStep
          activity={activity}
          task={task}
          bgColor={bgColor}
          isModal={isModal}
        />
      )
    case 'REMAINING_STEP':
      return (
        <TaskActivityBase
          name={activity.getTitle()}
          type={activity.step.type}
          bgColor={bgColor}
          isModal={isModal}
        />
      )
    case 'DONE':
      return (
        <TaskActivityBase
          name={activity.getTitle()}
          type={activity.type}
          active={task.status === 'DONE' || !!activity.date}
          lastStep={!activity?.date}
          color={activity.getStepTypeColor('DONE')}
          bgColor={bgColor}
          isModal={isModal}
        />
      )
    default:
      return null
  }
}
